module.exports = {
      id: "share-usage",
      viewBox: "0 0 13 13",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#share",
      toString: function () {
        return this.url;
      }
    }